import { objectToQueryString } from "../utils/common";
import BaseService from "./BaseService";
import { get } from "lodash";

class AuthenticationServices extends BaseService {
  constructor() {
    super();
    this.login = this.login.bind(this);
    this.getEmployee = this.getEmployee.bind(this);
    this.onlineInformation = this.onlineInformation.bind(this);
    this.workers = this.workers.bind(this);
    this.updateWorkers = this.updateWorkers.bind(this);
    this.setPassword = this.setPassword.bind(this);
    this.getProduct = this.getProduct.bind(this);
    this.getCustomer = this.getCustomer.bind(this);
    this.getDataReport = this.getDataReport.bind(this);
    this.postLoginHistory = this.postLoginHistory.bind(this);
    this.accecptNewDevice = this.accecptNewDevice.bind(this);
    this.oderListPost = this.oderListPost.bind(this);
    this.getFileFolderTree = this.getFileFolderTree.bind(this);
    this.getNotification = this.getNotification.bind(this);
    this.getNotificationDetail = this.getNotificationDetail.bind(this);
    this.postNotification = this.postNotification.bind(this);
    this.uploadFile = this.uploadFile.bind(this);
    this.fileManagerFolder = this.fileManagerFolder.bind(this);
    this.fileManagerUpload = this.fileManagerUpload.bind(this);
    this.updateHeader = this.updateHeader.bind(this);
    this.setupLogo = this.setupLogo.bind(this);
    this.getSetupLogo = this.getSetupLogo.bind(this);
    this.getChartConfigDatabase = this.getChartConfigDatabase.bind(this);
    this.getChartConfigDatabaseDetail = this.getChartConfigDatabaseDetail.bind(
      this
    );
    this.postChartConfigDatabase = this.postChartConfigDatabase.bind(this);
    this.putChartConfigDatabase = this.putChartConfigDatabase.bind(this);
    this.deleteChartConfigDatabase = this.deleteChartConfigDatabase.bind(this);
    this.testConnect = this.testConnect.bind(this);
    this.permissionAssign = this.permissionAssign.bind(this);
    this.permissonGet = this.permissonGet.bind(this);
    this.getCustomerGroup = this.getCustomerGroup.bind(this);
    this.getproductCategory = this.getproductCategory.bind(this);
    this.getOrganization = this.getOrganization.bind(this);
    this.setDatabaseDefault = this.setDatabaseDefault.bind(this);
    this.updateWorkerKpi = this.updateWorkerKpi.bind(this);
    this.getWorkerInfo = this.getWorkerInfo.bind(this);
    this.updateProductPosition = this.updateProductPosition.bind(this);
  }

  updateHeader(token) {
    this.service.defaults.headers.common["Authorization"] = `Bearer ${token}`;
  }

  login(info) {
    return this.post(`${process.env.REACT_APP_BASE_URL}/account/login`, info);
  }

  getEmployee(action) {
    const { ID, token } = action;
    let subPath = "";
    if (typeof ID === "object") {
      subPath = `${ID.ID}?accountObjectGroupId=${ID.accountObjectGroupId}`;
    } else {
      subPath = ID;
    }
    return this.get(
      `${process.env.REACT_APP_BASE_URL}/account/employee/${subPath}`,
      token
    );
  }

  onlineInformation(action) {
    const { Id, fromDate, toDate, showAll, token } = action;
    if (showAll) {
      return this.get(
        `${process.env.REACT_APP_BASE_URL}/account/employee/${Id}?showAll=true`,
        token
      );
    }
    return this.get(
      `${process.env.REACT_APP_BASE_URL}/account/employee/${Id}?fromDate=${fromDate}&toDate=${toDate}`,
      token
    );
  }

  workers(Id, token) {
    return this.get(
      `${process.env.REACT_APP_BASE_URL}/account/workers/${Id}`,
      token
    );
  }

  updateProductPosition({data, token}) {
    return this.post(
      `${process.env.REACT_APP_BASE_URL}/product/sort`,
      data,
      token
    );
  }

  updateWorkers(info, token) {
    return this.post(
      `${process.env.REACT_APP_BASE_URL}/account/update-workers`,
      info,
      token
    );
  }

  setPassword(info, token) {
    const AccountObjectCode = get(info, "AccountObjectCode");
    const Password = get(info, "Password");
    if (AccountObjectCode && Password && Password.length > 5) {
      this.put(
        `${process.env.REACT_APP_BASE_URL}/account/setPassword`,
        { AccountObjectCode, Password },
        token
      ).then();
    }
    return Promise.resolve();
  }

  getCustomer(action) {
    const { ID, token } = action;
    return this.get(
      `${process.env.REACT_APP_BASE_URL}/customer?userId=${ID}&limit=1000`,
      token
    );
  }
  getProduct(action) {
    const { token } = action;
    return this.get(
      `${process.env.REACT_APP_BASE_URL}/product?keyword=`,
      token
    );
  }
  getDataReport(action, oderList) {
    const { data, token } = action;
    if (oderList) {
      return this.post(
        `${process.env.REACT_APP_BASE_URL}/report/danhsachdonhang`,
        data,
        token
      );
    }
    return this.post(
      `${process.env.REACT_APP_BASE_URL}/report/doanh-so-ban-hang-theo-mat-hang`,
      data,
      token
    );
  }

  oderListPost(action) {
    const { data, token } = action;
    return this.post(
      `${process.env.REACT_APP_BASE_URL}/report/danhsachdonhang`,
      data,
      token
    );
  }

  postLoginHistory(action) {
    const { data, token } = action;
    return this.post(
      `${process.env.REACT_APP_BASE_URL}/account/login/history`,
      data,
      token
    );
  }

  accecptNewDevice(action) {
    const { data, token } = action;
    return this.post(
      `${process.env.REACT_APP_BASE_URL}/account/accecpt-new-device`,
      data,
      token
    );
  }

  // Manager File
  getFileFolderTree(action) {
    const { data, token } = action;

    return this.get(
      `${process.env.REACT_APP_BASE_URL}/file/tree-folder?${objectToQueryString(data)}`,
      token
    );
  }

  getNotification(action) {
    const { data, token } = action;
    return this.get(
      `${process.env.REACT_APP_BASE_URL}/notification?${objectToQueryString(data)}`,
      token
    );
  }
  getNotificationDetail(action) {
    const { data, token } = action;
    return this.get(
      `${process.env.REACT_APP_BASE_URL}/notification/${data}`,
      token
    );
  }
  postNotification(action) {
    const { data, token } = action;
    return this.post(
      `${process.env.REACT_APP_BASE_URL}/notification`,
      data,
      token
    );
  }

  uploadFile(action) {
    const { data, token } = action;
    return this.post(
      `${process.env.REACT_APP_BASE_URL}/upload`,
      data,
      token
    );
  }

  fileManagerFolder(action) {
    const { data, token } = action;
    return this.post(
      `${process.env.REACT_APP_BASE_URL}/file/manage-folder`,
      data,
      token
    );
  }

  fileManagerUpload(action) {
    const { data, path, token } = action;
    return this.postFile(
      `${process.env.REACT_APP_BASE_URL}/file/upload?path=${path}`,
      data,
      token
    );
  }

  setupLogo(action) {
    const { data, token } = action;
    return this.post(
      `${process.env.REACT_APP_BASE_URL}/logo/config`,
      data,
      token
    );
  }

  getSetupLogo(action) {
    const { token } = action;
    return this.get(
      `${process.env.REACT_APP_BASE_URL}/logo/config`,
      token
    );
  }

  getChartConfigDatabase(action) {
    const { data, token } = action;
    return this.get(
      `${process.env.REACT_APP_BASE_URL}/manage-db?${objectToQueryString(
        data
      )}`,
      token
    );
  }

  getChartConfigDatabaseDetail(action) {
    const { data, token } = action;
    return this.get(
      `${process.env.REACT_APP_BASE_URL}/manage-db/${data}`,
      token
    );
  }
  postChartConfigDatabase(action) {
    const { data, token } = action;
    return this.post(
      `${process.env.REACT_APP_BASE_URL}/manage-db`,
      data,
      token
    );
  }
  putChartConfigDatabase(action) {
    const { data: { ID, ...data }, token } = action;
    return this.put(
      `${process.env.REACT_APP_BASE_URL}/manage-db/${ID}`,
      data,
      token
    );
  }
  deleteChartConfigDatabase(action) {
    const { data, token } = action;
    return this.delete(
      `${process.env.REACT_APP_BASE_URL}/manage-db/${data}`,
      token
    );
  }
  setDatabaseDefault(action) {
    const { id, token } = action;
    return this.put(
      `${process.env.REACT_APP_BASE_URL}/manage-db/${id}/default`,
      {},
      token
    );
  }

  testConnect(action) {
    const { data, token } = action;
    delete data.ID;
    return this.post(
      `${process.env.REACT_APP_BASE_URL}/manage-db/validate`,
      data,
      token
    );
  }

  permissionAssign(action) {
    const { data, token } = action;
    delete data.ID;
    return this.post(
      `${process.env.REACT_APP_BASE_URL}/permission/assign`,
      data,
      token
    );
  }

  permissonGet(action) {
    const { accountObjectCode, token } = action;
    return this.get(
      `${process.env.REACT_APP_BASE_URL}/permission/${accountObjectCode}`,
      token
    );
  }

  getCustomerGroup(action) {
    const { token } = action;
    return this.get(
      `${process.env.REACT_APP_BASE_URL}/customer/group`,
      token
    );
  }

  getproductCategory(action) {
    const { token } = action;
    return this.get(
      `${process.env.REACT_APP_BASE_URL}/product/category`,
      token
    );
  }

    getOrganization(action) {
    const { token } = action;
    return this.get(
      `${process.env.REACT_APP_BASE_URL}/account/organization`,
      token
    );
  }

  updateWorkerKpi(action) {
    const { kpi, token } = action;
    return this.post(
        `${process.env.REACT_APP_BASE_URL}/account/workers/info`,
        kpi,
        token
      );
  }

  getWorkerInfo(action) {
    const { data: { accountObjectCode, fromDate, toDate }, token } = action;
    return this.get(
      `${process.env.REACT_APP_BASE_URL}/account/workers/${accountObjectCode}/info?fromDate=${fromDate}&toDate=${toDate}`,
      token
    );
  }

  getNotificationById(action) {
    const { id, token } = action;
    return this.get(
      `${process.env.REACT_APP_BASE_URL}/notification/${id}`,
      token
    );
  }

  deleteNotificationById(action) {
    const { id, token } = action;
    return this.delete(
      `${process.env.REACT_APP_BASE_URL}/notification/${id}`,
      token
    );
  }
}

export default new AuthenticationServices();
